import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/na87/list_icon_pro.png'
import { NA87 } from './na87'
import { EffectIndex, KK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_PRO } from '../../light/light_effect_list'

export class NA87Pro extends NA87 {
  name: string = 'NA87_PRO'
  icon: string = list_icon
  width: number = 770
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO

  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = true
  inoperableKeys: KK[] = [0x01]
  y_number: number = 10
  fnDisableKeys: KK[] = [0x3a, 0x3b, 0x3c, 0x3d, 0x3e, 0x3f, 0x40, 0x41, 0x42, 0x43, 0x44, 0x45, 0x47, 0x49, 0x4c, 0x52, 0x50, 0x51, 0x4f, 0x04, 0x16, 0xe3]

  customLayout: CustomLayout = {
    0x3a: this.createSquare(59),
    0x3e: this.createSquare(8, 2),

    0x35: this.createSquare(2, this.y_number),
    0x1e: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x20: this.createSquare(2, this.y_number),
    0x21: this.createSquare(2, this.y_number),
    0x22: this.createSquare(2, this.y_number),
    0x23: this.createSquare(2, this.y_number),
    0x24: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x26: this.createSquare(2, this.y_number),
    0x27: this.createSquare(2, this.y_number),
    0x2d: this.createSquare(2, this.y_number),
    0x2e: this.createSquare(2, this.y_number),
    0x2a: this.createSquare(2, this.y_number, 67.5),
    0x49: this.createSquare(9, this.y_number),
    0x4a: this.createSquare(2, this.y_number),
    0x4b: this.createSquare(2, this.y_number),
    0x42: this.createSquare(8, 2),
    0x46: this.createSquare(9, 2),

    0x2b: this.createSquare(2, 2, 48),
    0x31: this.createSquare(2, 2, 59),
    0x4c: this.createSquare(9, 2),
    0x39: this.createSquare(2, 2, 55),
    0x28: this.createSquare(2, 2, 93.5),
    0xe1: this.createSquare(2, 2, 76),
    0xe5: this.createSquare(2, 2, 114),
    0x01: this.createSquare(2, 2, 54),
    0xe4: this.createSquare(2, 2, 54),
    0x65: this.createSquare(2, 2, 54),
    0x52: this.createSquare(50.5, 2),

    0xe0: this.createSquare(2, 2, 54),
    0xe2: this.createSquare(2, 2, 54),
    0xe3: this.createSquare(2, 2, 54),
    0x2c: this.createSquare(2, 2, 215),
    0xe6: this.createSquare(2, 2, 54),
    0x50: this.createSquare(9, 2),
  }
}
